var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessManagementOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Access_Management_Outline",
    "data-name": "Access Management Outline",
    transform: "translate(-333 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base",
    transform: "translate(333 306)",
    fill: "#fe7b43",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Access_Management_Outline-2",
    "data-name": "Access Management Outline",
    transform: "translate(335.609 309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    "data-name": "Path 3118",
    d: "M89.245,7.826a3.913,3.913,0,1,1,3.913-3.913A3.917,3.917,0,0,1,89.245,7.826Zm0-6.652a2.739,2.739,0,1,0,2.739,2.739,2.742,2.742,0,0,0-2.739-2.739Zm0,0",
    transform: "translate(-82.202)",
    fill: "#fe7b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    "data-name": "Path 3119",
    d: "M325.674,346.81h-4.3a1.371,1.371,0,0,1-1.37-1.37V342.7a1.371,1.371,0,0,1,1.37-1.37h4.3a1.371,1.371,0,0,1,1.37,1.37v2.739A1.371,1.371,0,0,1,325.674,346.81Zm-4.3-4.3a.2.2,0,0,0-.2.2v2.739a.2.2,0,0,0,.2.2h4.3a.2.2,0,0,0,.2-.2V342.7a.2.2,0,0,0-.2-.2Zm0,0",
    transform: "translate(-308.261 -328.81)",
    fill: "#fe7b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3120",
    "data-name": "Path 3120",
    d: "M365.994,260.3h-2.739a.587.587,0,0,1-.587-.587v-1.761a1.956,1.956,0,0,1,3.913,0v1.761A.587.587,0,0,1,365.994,260.3Zm-2.152-1.174h1.565v-1.174a.783.783,0,0,0-1.565,0Zm0,0",
    transform: "translate(-349.364 -246.609)",
    fill: "#fe7b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    "data-name": "Path 3121",
    d: "M9.783,263.043H.587A.587.587,0,0,1,0,262.457v-2.739A3.722,3.722,0,0,1,3.717,256h6.848a3.707,3.707,0,0,1,1.862.5.587.587,0,1,1-.591,1.014,2.536,2.536,0,0,0-1.271-.341H3.717a2.546,2.546,0,0,0-2.543,2.543v2.152H9.783a.587.587,0,0,1,0,1.174Zm0,0",
    transform: "translate(0 -246.609)",
    fill: "#fe7b43"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessManagementOutline);
export default __webpack_public_path__ + "static/media/accessManagementOutline.94950024f2fd108c97f209825b8e5a75.svg";
export { ForwardRef as ReactComponent };